// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"371":"7c70b483","453":"a002105b"}[chunkId] + ".chunk.js";
};